<!-- ag-grid's own checkbox markup so the header box matches the row checkboxes;
     keyboard focus stays on the header cell (Space toggles, see agInit). -->
<div
  class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
  [class.ag-checked]="state() === 'all'"
  [class.ag-indeterminate]="state() === 'some'"
  [class.ag-disabled]="disabled()"
>
  <!-- scanner-disable-next-line R6 -- mirrors ag-grid's row checkbox markup and theme (WAP-1750) -->
  <input
    type="checkbox"
    class="ag-input-field-input ag-checkbox-input"
    tabindex="-1"
    [checked]="state() === 'all'"
    [indeterminate]="state() === 'some'"
    [disabled]="disabled()"
    [attr.aria-label]="'grid.selection.select-all-rows-on-this-page' | translate"
    (click)="$event.preventDefault(); toggle()"
  />
</div>
